export default __webpack_public_path__ + "a4606303253077ab3bb93c8f3852d7d1.png";